import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, IconButton, InputAdornment, TextField, Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { QRCodeSVG } from 'qrcode.react';

interface QRCodeDialogProps {
  open: boolean;
  onClose: () => void;
  url: string;
}

const QRCodeDialog: React.FC<QRCodeDialogProps> = ({ open, onClose, url }) => {
  const [copySuccess, setCopySuccess] = React.useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(url);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>分享連結</DialogTitle>
      <DialogContent sx={{ textAlign: 'center' }}>
        <QRCodeSVG value={url} size={180} style={{ margin: '16px auto' }} />
        <Typography variant="body2" sx={{ mt: 2, mb: 1 }}>
          掃描 QR Code 以分享你的 Check Points
        </Typography>
        <TextField
          value={url}
          fullWidth
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleCopy}>
                  <ContentCopyIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{ my: 1 }}
        />
        {copySuccess && (
          <Typography color="success.main" variant="caption">已複製！</Typography>
        )}
        <Button onClick={onClose} fullWidth sx={{ mt: 2 }}>關閉</Button>
      </DialogContent>
    </Dialog>
  );
};

export default QRCodeDialog; 